// Saved downloads are unzipped on Windows, whose Extract All puts a ZIP's files in a folder named
// after the ZIP and fails on a path over 260 characters. Names the app composes stay within the
// same limit the export names keep.
export const MAX_SAVED_FILE_NAME_LENGTH = 70;

const TRAILING_SEPARATORS = /[\s\-,.;:(&_+]+$/;

const isHighSurrogate = (char) => /[\uD800-\uDBFF]/.test(char);

// Shortens a name to at most maxLength characters. The cut moves back to the last word break when
// one lies in the second half, never splits a character such as an emoji, and a separator left
// dangling at the end is dropped.
export const shortenFileName = (text, maxLength = MAX_SAVED_FILE_NAME_LENGTH) => {
  const value = String(text ?? "").trim();
  if (maxLength <= 0) return "";
  if (value.length <= maxLength) return value;

  let cut = value.slice(0, maxLength);
  const lastBreak = cut.lastIndexOf(" ");
  if (!/\s/.test(value[maxLength]) && lastBreak >= Math.floor(maxLength / 2)) {
    cut = cut.slice(0, lastBreak);
  } else if (isHighSurrogate(cut.at(-1))) {
    cut = cut.slice(0, -1);
  }
  return cut.replace(TRAILING_SEPARATORS, "") || cut.trim();
};
